import { DataTable } from "../../components/DataTable.tsx";
import { Button } from "../../components/ui/button.tsx";
import { FaEye } from "react-icons/fa";
import Modal from "../../components/Modal.tsx";
import React, { useEffect, useState } from "react";
import { requestService, requestDataMap } from "../../services";
import useUserStore2 from "../../stores/userStore2";
import { createItemStore } from "../../stores/createItemStore";
import LoadingImage from "../../components/LoadingImage";
import ShortenedText from "../../components/ShortenedText";
import StatusBadge from "../../components/table/StatusBadge"

const columns = [
  {
    accessorKey: "dateCreated",
    header: "Date Created",
    cell: ({ row }) => <span>{row.getValue("dateCreated")}</span>,
  },
  {
    accessorKey: "requestId",
    header: "Request ID",
    cell: ({ row }) => (
      <span>
        <ShortenedText text={row.getValue("requestId")} />
      </span>
    ),
  },
  {
    accessorKey: "type",
    header: "Type",
    cell: ({ row }) => {
      const type = row.getValue("type");
      return (
        <div className="flex items-center h-full min-h-[40px]">
          <span
            className={`inline-block px-3 py-1 text-xs font-semibold rounded-full border ${
              type === "Invitation" ? "text-green-600 border-green-600"
              : type === "Activation" ? "text-blue-600 border-blue-500"
              : type === "Suspension" ? "text-orange-500 border-orange-500"
              : type === "Removal" ? "text-red-600 border-red-600"
              : type === "Transaction" ? "text-gray-800 border-gray-800"
              : type === "Reassignment" ? "text-yellow-600 border-yellow-600"
              : "text-gray-500 border-gray-500"
            }`}
          >
            {type}
          </span>
        </div>
      )
    },
  },
  // {
  //   accessorKey: "pocName",
  //   header: "POC",
  //   cell: ({ row }) => <span>{row.getValue("pocName")}</span>,
  // },
  // {
  //   accessorKey: "material",
  //   header: "Material",
  //   cell: ({ row }) => <span>{row.getValue("material")}</span>,
  // },
  // {
  //   accessorKey: "quantity",
  //   header: "Quantity",
  //   cell: ({ row }) => <span>{row.getValue("quantity")}</span>,
  // },
  {
    accessorKey: "status",
    header: "Status",
    cell: ({ row }) => {
      const status = row.getValue("status");
      return (
        <StatusBadge status={status} />
      );
    },
  },
];

// ========================================================
// Step 1: Zustand store instantiation
// ========================================================
const storeName = "my-requests";
const useItems = createItemStore(
  storeName,
  (request) => request.requestId,
  (args) => requestService.getRequests(args[0], args[1], args[2], args[3], args[4], args[5]), // Modified to use EntityId and Type
  requestDataMap
);
// ========================================================

export default function MyRequests() {
  const [isViewOpen, setIsViewOpen] = useState(false);
  const [selectedTransaction, setSelectedTransaction] = useState(null);

  const { user } = useUserStore2((state) => state);

  const handleViewTransaction = (transaction) => {
    setSelectedTransaction(transaction);
    setIsViewOpen(true);
  };

  const actions = (row) => [
    {
      label: "View details",
      icon: <FaEye />,
      onClick: () => handleViewTransaction(row),
      variant: "dropPlain",
    },
  ];

  // ========================================================
  // Step 2: Zustand store and page hydration
  // ========================================================
  const { isLoading, fetchItems, getSortedFiltered } = useItems(
    (state) => state
  );

  // const data = user?.id
  //   ? getSortedFiltered((request) => {
  //       return (
  //         request.requestEntityId === user?.id
  //         && request.requestProfileId === user?.currentProfile?.id
  //         // && request.type === "Transaction"
  //       );
  //     }) // Filter by user.id for now
  //   : getSortedFiltered();
  const data = getSortedFiltered((request) =>
    request.requestEntityId === user?.id
    && request.requestProfileId === user?.currentProfile?.id
  );

  const showLoading = data.length === 0 && isLoading;
  console.log(`${storeName}:`, data);
  console.log(`user?.id:`, user?.id);
  console.log(`user?.currentProfile?.id:`, user?.currentProfile?.id);

  // Pass EntityId as first arg and Type as second arg
  const arg = [user?.id, user?.currentProfile?.id];
  console.log(`arg:`, arg);

  useEffect(() => {
    // Only fetch when userId is available
    if (user?.id) {
      fetchItems({}, arg);
    }
  }, [user?.id, user?.currentProfile?.id]);
  // ========================================================

  return (
    <div className="flex flex-col md:flex-row min-h-screen">
      <div className="flex-1 flex flex-col">
        <div className="p-8 flex flex-col">
          <div className="bg-white shadow rounded-lg p-4 sm:p-6 text-sm md:mt-0">
            <div className="flex flex-col sm:flex-row justify-between items-center mb-4">
              <div className="text-base sm:text-lg font-semibold text-[#111827] mb-4 sm:mb-0">
                My Requests List
              </div>
            </div>
            <hr />
            <div className="overflow-x-auto w-full max-w-screen-lg">
              {showLoading ? (
                // && {getAllRequests.loading
                // && isRequestTableEmpty(page, "entity", user?.id)
                <LoadingImage />
              ) : data.length > 0 ? (
                // ) : filteredRequests.length > 0 ? (
                <DataTable
                  columns={columns}
                  data={[...(data ?? [])].reverse()}
                  // data={[...(filteredRequests ?? [])].reverse()}
                  actions={actions}
                />
              ) : (
                <div className="text-center text-gray-500 py-6">
                  No requests found.
                </div>
              )}
            </div>
          </div>
        </div>

        {/* View Modal */}
        <Modal
          isOpen={isViewOpen}
          onClose={() => setIsViewOpen(false)}
          title="View MyRequests Details"
          description="Here are the details for this transaction."
          icon={<FaEye className="text-blue-500" />}
          actions={
            <div className="flex justify-between w-full">
              <Button
                variant={"secondary"}
                onClick={() => setIsViewOpen(false)}
              >
                Close
              </Button>
            </div>
          }
        >
          {/* Modal Content Wrapper */}
          <div className="max-h-[70vh] overflow-y-auto space-y-6 px-4">
            {selectedTransaction ? (
              <div className="grid gap-4">
                <div className="flex items-center px-4 py-2 bg-gray-100">
                  <div className="font-semibold w-1/2 text-left">
                    My Requests ID:
                  </div>
                  <span className="text-left w-1/2">
                    {selectedTransaction.requestId}
                  </span>
                </div>

                <div className="flex items-center px-4 py-2 bg-white">
                  <div className="font-semibold w-1/2 text-left">
                    Date Created:
                  </div>
                  <span className="text-left w-1/2">
                    {selectedTransaction.dateCreated || "N/A"}
                  </span>
                </div>

                <div className="flex items-center px-4 py-2 bg-gray-100">
                  <div className="font-semibold w-1/2 text-left">
                    Date Updated:
                  </div>
                  <span className="text-left w-1/2">
                    {selectedTransaction.dateUpdated || "N/A"}
                  </span>
                </div>

                <div className="flex items-center px-4 py-2 bg-white">
                  <div className="font-semibold w-1/2 text-left">
                    Profile ID:
                  </div>
                  <span className="text-left w-1/2">
                    {selectedTransaction.requestProfileId || "N/A"}
                  </span>
                </div>

                <div className="flex items-center px-4 py-2 bg-gray-100">
                  <div className="font-semibold w-1/2 text-left">
                    Profile Name:
                  </div>
                  <span className="text-left w-1/2">
                    {selectedTransaction.profileName || "N/A"}
                  </span>
                </div>

                <div className="flex items-center px-4 py-2 bg-white">
                  <div className="font-semibold w-1/2 text-left">POC ID:</div>
                  <span className="text-left w-1/2">
                    {selectedTransaction.pocId || "N/A"}
                  </span>
                </div>

                <div className="flex items-center px-4 py-2 bg-gray-100">
                  <div className="font-semibold w-1/2 text-left">POC Name:</div>
                  <span className="text-left w-1/2">
                    {selectedTransaction.pocName || "N/A"}
                  </span>
                </div>

                <div className="flex items-center px-4 py-2 bg-white">
                  <div className="font-semibold w-1/2 text-left">
                    Material Category:
                  </div>
                  <span className="text-left w-1/2">
                    {selectedTransaction.material || "N/A"}
                  </span>
                </div>

                <div className="flex items-center px-4 py-2 bg-gray-100">
                  <div className="font-semibold w-1/2 text-left">Quantity:</div>
                  <span className="text-left w-1/2">
                    {selectedTransaction.quantity || "N/A"}
                  </span>
                </div>

                <div className="flex items-center px-4 py-2 bg-white">
                  <div className="font-semibold w-1/2 text-left">Status:</div>
                  <span className="text-left w-1/2">
                    {selectedTransaction.status || "N/A"}
                  </span>
                </div>

                <div className="flex items-center px-4 py-2 bg-gray-100">
                  <div className="font-semibold w-1/2 text-left">
                    Description:
                  </div>
                  <span className="text-left w-1/2">
                    {selectedTransaction.description || "N/A"}
                  </span>{" "}
                  {/* Placeholder text for reason */}
                </div>
              </div>
            ) : (
              <p>No data available</p>
            )}
          </div>
        </Modal>
      </div>
    </div>
  );
}
